module.exports = __webpack_public_path__ + "img/footerLogo.f71bd2d7.svg";